<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <div :class="blockStyle">
    <data-icon v-if="icon" :icon="icon" :isUmbraco="isUmbraco" />
    <data-title
      :text="title"
      :isUmbraco="isUmbraco"
      :theme="theme"
      classes="lg:text-[22px] font-bold lg:leading-[140%] lg:pb-2"
    />
    <rich-text
      v-if="content"
      :text="content"
      :isUmbraco="isUmbraco"
      :theme="theme"
      classes="lg:text-[24px] lg:leading-[150%] lg:pb-5"
    />
  </div>
</template>

<script lang="ts" setup>
import DataTitle from "@/components/Typography/DataTitle.ce.vue";
import RichText from "@components/Typography/RichText.ce.vue";
import DataIcon from "@/components/Atoms/DataItems/DataIcon.ce.vue";
import { computed } from "vue";

export interface NumberItemProps {
  classes?: string;
  theme: "dark" | "light";
  isActive?: boolean;
  title: string;
  content?: string;
  index: number;
  isUmbraco?: boolean;
  icon?: string;
}

const props = withDefaults(defineProps<NumberItemProps>(), {
  theme: "light",
  isUmbraco: false,
});

const blockStyle = computed(() => {
  return `relative flex-25 lg:flex-50 pt-5 lg:pt-3 pb-7 lg:py-2`;
});
</script>
